export enum GeneratorProductModalType {
  DeleteItem = 'DeleteItem',
  SaveItem = 'SaveItem',
  UpdateProducts = 'UpdateProducts',
  UserProductDuplicated = 'UserProductDuplicated',
  None = 'None',
}
